// extracted by mini-css-extract-plugin
export default {"tooltip-button":"TooltipButton_tooltip-button__L4D56","tooltip-button__hint":"TooltipButton_tooltip-button__hint__t6fG7"};